import { render, staticRenderFns } from "./SSCategorySelector.vue?vue&type=template&id=83df4626&scoped=true&"
import script from "./SSCategorySelector.vue?vue&type=script&lang=js&"
export * from "./SSCategorySelector.vue?vue&type=script&lang=js&"
import style0 from "./SSCategorySelector.vue?vue&type=style&index=0&id=83df4626&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83df4626",
  null
  
)

export default component.exports